import { ExportVisibility } from '@aibees/elephant/hooks';
import { useSocketExportChanges } from '@aibees/elephant/hooks/use-socket-export-changes';
import { useExportsMetadataStore } from '@aibees/elephant/store/exports-metadata';
import { classnames } from '@aibees/shared/utils';
import { memo, useMemo } from 'react';
import { CardVisibilityTabs } from '../card-visibility-tabs';
import { config } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { ExportTableProps as Props } from './types';

const ExportVisibilityTabs = memo(function ExportVisibilityTabs() {
  const metadata = useExportsMetadataStore((s) => s.metadata);
  const counts = useMemo(
    () =>
      metadata
        ? {
            private: metadata[ExportVisibility.PRIVATE],
            internal: metadata[ExportVisibility.INTERNAL],
          }
        : undefined,
    [metadata]
  );
  return <CardVisibilityTabs counts={counts} />;
});

const renderPrepend = () => <ExportVisibilityTabs />;
const finalConfig = { ...config, renderTablePrependStable: renderPrepend };

export const ExportTable = memo(({ className }: Props) => {
  useSocketExportChanges();

  return (
    <Styled.Wrapper
      className={classnames('ExportTable', className)}
      sx={SX.root}
      config={finalConfig}
    />
  );
});

ExportTable.displayName = 'ExportTable';
